module.exports = __webpack_public_path__ + "img/hu.2465e0c1.svg";